import { sanitizeTextInput } from '../firmUtils';
import { FIRM_FIELD_LIMITS } from '../firmConstants';

const hasNonWhitespaceText = value => sanitizeTextInput(value).length > 0;
const hasTwoLetterStateCode = value => /^[A-Za-z]{2}$/.test(sanitizeTextInput(value));
const isValidZipCode = value => /^[0-9-]*$/.test(sanitizeTextInput(value));
const exceedsMaxLength = (value, maxLength) => sanitizeTextInput(value).length > maxLength;

export const validateCreate = values => {
  const errors = {};
  const currentValues = values || {};

  if (!hasNonWhitespaceText(currentValues.extrn_company_name)) {
    errors.extrn_company_name = 'Firm Name is required';
  } else if (exceedsMaxLength(currentValues.extrn_company_name, FIRM_FIELD_LIMITS.FIRM_NAME)) {
    errors.extrn_company_name = `Firm Name should have ${FIRM_FIELD_LIMITS.FIRM_NAME} or less characters`;
  }

  if (!hasNonWhitespaceText(currentValues.extrn_addr_line1)) {
    errors.extrn_addr_line1 = 'Address Line 1 is required';
  } else if (exceedsMaxLength(currentValues.extrn_addr_line1, FIRM_FIELD_LIMITS.ADDRESS_LINE)) {
    errors.extrn_addr_line1 = `Address Line 1 should have ${FIRM_FIELD_LIMITS.ADDRESS_LINE} or less characters`;
  }

  if (hasNonWhitespaceText(currentValues.extrn_addr_line2)
    && exceedsMaxLength(currentValues.extrn_addr_line2, FIRM_FIELD_LIMITS.ADDRESS_LINE)) {
    errors.extrn_addr_line2 = `Address Line 2 should have ${FIRM_FIELD_LIMITS.ADDRESS_LINE} or less characters`;
  }

  if (!hasNonWhitespaceText(currentValues.extrn_city_name)) {
    errors.extrn_city_name = 'City is required';
  } else if (exceedsMaxLength(currentValues.extrn_city_name, FIRM_FIELD_LIMITS.CITY)) {
    errors.extrn_city_name = `City should have ${FIRM_FIELD_LIMITS.CITY} or less characters`;
  }

  if (!hasNonWhitespaceText(currentValues.extrn_st_prov_cd)) {
    errors.extrn_st_prov_cd = 'State is required';
  } else if (!hasTwoLetterStateCode(currentValues.extrn_st_prov_cd)) {
    errors.extrn_st_prov_cd = 'State input value should be a two-letter abbreviation';
  }

  if (!hasNonWhitespaceText(currentValues.extrn_postal_cd)) {
    errors.extrn_postal_cd = 'Zip Code is required';
  } else if (exceedsMaxLength(currentValues.extrn_postal_cd, FIRM_FIELD_LIMITS.ZIP)) {
    errors.extrn_postal_cd = `Zip Code should have ${FIRM_FIELD_LIMITS.ZIP} or less characters`;
  } else if (!isValidZipCode(currentValues.extrn_postal_cd)) {
    errors.extrn_postal_cd = 'Zip Code can only contain numbers and hyphens';
  }

  return errors;
};

export const validate = validateCreate;
